<template>
    <div class="row top announcement">
        <div class="row announcement-title">
            <input type="text" class="form-control text-center" placeholder="Τίτλος" v-model="form.title">
        </div>
        <div class="row announcement-body" style="padding-top: 20px">
            <textarea placeholder="Κείμενο" rows="10" class="form-control text-center" style="width: 100%"
                v-model="form.body"></textarea>
        </div>
    </div>
</template>
<script>

export default {
    props: ['form'],
    data() {
        return {
            localTitle: this.title,
            localBody: this.body
        }
    },
}
</script>
<style lang="scss" scoped>
.announcement {
    input,
    textarea {
        box-shadow: 0 15px 30px rgb(0 0 0 / 5%), 0 5px 5px rgb(0 0 0 / 5%);
        resize: vertical;
    }
}
</style>